<template>
    <div  class="page-setting has-bc biz-edit-landlord-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                房東基本資料
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        屋主姓名
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.name?landlordInfo.name:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        合約姓名
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.nameForContract?landlordInfo.nameForContract:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        身分證字號
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.idNumber?landlordInfo.idNumber:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        出生日期
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.birthday?landlordInfo.birthday:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        性別
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.isMale === false?'女':'男'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        房東簽名
                        </div>
                        <div class="biz-table-content">
                            <div v-if="landlordInfo.signatureBase64" class="sinature-wrap h-align">
                                <img :src="'data:image/png;base64,'+landlordInfo.signatureBase64" alt="" srcset="">
                            </div>
                            <div v-else>
                                -
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                房東聯絡資訊
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        住家電話
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.telephone?landlordInfo.telephone:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        手機號碼
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.mobilePhone?landlordInfo.mobilePhone:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        電子郵件
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.email?landlordInfo.email:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        Line ID
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.lineId?landlordInfo.lineId:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        聯絡地址
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.completeAddress?landlordInfo.completeAddress:'-'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                其他
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        對帳日期
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.reconcileDayOfMonth?'每月 '+landlordInfo.reconcileDayOfMonth+' 號':'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        開發人員
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.developer?landlordInfo.developer:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        備註
                        </div>
                        <div class="biz-table-content">
                            {{landlordInfo.remark?landlordInfo.remark:'-'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    mounted () {
        // 取得詳細
        this.getInfo(this.$route.query.cId)
    },
    watch: {
    },
    methods: {
        // getEmployeeRoleList: function () {
        //     this.$store.dispatch('getBizEmployeeRoleList')
        // },
        // getOrganizationGroupList: function () {
        //     this.$store.dispatch('getBizOrganizationGroupList')
        // },
        getInfo: function (id) {
            this.$store.dispatch('getBizLanlordInfo', id)
        },
    },
    computed: {
        ...mapGetters({
            landlordInfo: 'GET_BIZ_LANDLORD_INFO',
        })
    },
    components: {
        toogleBlock,
        RentSelect,
    }
}
</script>
<style lang="scss">
    .biz-edit-landlord-comp{
        .toggle-block > .toogle-body {
            padding: 0 24px 24px 24px;
        }
        .biz-table{
            .biz-table-row{
                .biz-table-title{
                    width: 85px;
                }
                .sinature-wrap{
                    width: 200px;
                    height: 100px;
                    border-radius: 6px;
                    border: solid 1px #e0dfde;
                    background-color: #f6f6f6;
                    overflow: hidden;
                    >img{
                        width: 100%;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/landlordMgt/viewLandlordComp.vue